import memoizeOne from 'memoize-one'

import { decodeJwt, tokenPayloads } from '../../utils/tokenTools'

export const tokenHasMagentoUserScope = memoizeOne((token: string | undefined) => {
  if (!token) {
    return false
  }
  const decodedToken = decodeJwt(token)
  const apiScopes = (decodedToken?.payload?.scope as string)?.split(' ') ?? []
  return apiScopes.includes('magento_user')
})

export const tokenHasReadProfessionalScope = memoizeOne((token: string | undefined) => {
  if (!token) {
    return false
  }
  const decodedToken = decodeJwt(token)
  const apiScopes = (decodedToken?.payload?.scope as string)?.split(' ') ?? []
  return apiScopes.includes('read:professional_library')
})

export const decodeTokenCustomerId = memoizeOne((token: string) => {
  const decodedToken = decodeJwt(token)
  const customerId = decodedToken?.payload[tokenPayloads.customerId] as string
  return customerId
})
